/* global fbq */

// 1. Пользователь открыл страницу
const fbPageView = () => {
  fbq('track', 'PageView');
};

// 2. Пользователь выбрал пол
const fbSearch = () => {
  fbq('track', 'Search');
};

// 3. Пользователь оставил Email
const fbCompleteRegistration = () => {
  fbq('track', 'CompleteRegistration');
};

// 4. Пользователь перешел на экран пейвола или upsale
const fbAddToCart = () => {
  fbq('track', 'AddToCart');
};

// 5. Пользователь начал взаимодействие с Apple Pay, GooglePay, PayPal или картой
const fbInitiateCheckout = () => {
  fbq('track', 'InitiateCheckout');
};

// 6. Пользователь оплатил подписку (серверный ивент)
const fbPurchase = () => {
  fbq('track', 'Purchase');
};

export {
  fbPageView,
  fbSearch,
  fbCompleteRegistration,
  fbAddToCart,
  fbInitiateCheckout,
  fbPurchase
};
